var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.24686 1.37186C9.41771 1.201 9.41771 0.923995 9.24686 0.753141C9.076 0.582286 8.799 0.582286 8.62814 0.753141L5 4.38128L1.37186 0.753141C1.201 0.582286 0.923995 0.582286 0.753141 0.753141C0.582286 0.923995 0.582286 1.201 0.753141 1.37186L4.38128 5L0.753141 8.62814C0.582286 8.799 0.582286 9.076 0.753141 9.24686C0.923995 9.41771 1.201 9.41771 1.37186 9.24686L5 5.61872L8.62814 9.24686C8.799 9.41771 9.076 9.41771 9.24686 9.24686C9.41771 9.076 9.41771 8.799 9.24686 8.62814L5.61872 5L9.24686 1.37186Z",
    fill: "#22264C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClose);
export default __webpack_public_path__ + "static/media/ic_close.017c7931.svg";
export { ForwardRef as ReactComponent };